
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import Icon from 'UI/FontAwesomeIcon'
import { isNull } from 'lodash'
import { Query } from 'Utilities/incognitaAPI'
import CSRFToken from 'UI/CSRFToken'

const GET_ASSETS_COUNT = `
  query AssetsCount($id: ID!) {
    importConfigurationReportAssetsCount(id: $id)
  }
`

const DeletePopup = ({ importID, setImportID }) => {
  const [assetsCount, setAssetsCount] = useState(null)
  const [loading, setLoading] = useState(true)

  const handleClose = () => setImportID(null)

  const fetchAssetsCount = () => {
    if (isNull(importID)) return

    setLoading(true)

    Query(GET_ASSETS_COUNT, { id: importID })
      .then(res => setAssetsCount(res.importConfigurationReportAssetsCount))
      .finally(() => setLoading(false))
  }

  useEffect(fetchAssetsCount, [importID])

  return (
    <div
      className="modal show"
      style={{ display: 'block', position: 'initial' }}
    >
      <Modal show={importID} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-2">
            Are you sure you want to soft delete all assets related to this
            import configuration?
          </div>

          Assets to be deleted:

          <span className="ml-1">
            {loading ?
              <Icon className="animate-spin" icon="spinner" /> :
              <b>{assetsCount}</b>
            }
          </span>
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-danger" onClick={handleClose}>
            Discard
          </Button>
          
          <form action={`/system/import_configurations/${importID}`} method="POST">
            <CSRFToken />
            <input type="hidden" name="_method" value="DELETE" />

            <Button type="submit" variant="primary">
              Remove
            </Button>
          </form>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default DeletePopup